import { type ClientContext, ContextClient } from '~/services/contextClient';
import BlastForecastClientFactory from './blastForecastClient.factory';
import { type BlastForecastClientInterface, type GetBlastForecastRequest } from './blastForecastClient.types';

class BlastForecastClient extends ContextClient<BlastForecastClientInterface> {
    constructor() {
        super(BlastForecastClientFactory);
    }

    getBlastForecastSummary(context: ClientContext, params: GetBlastForecastRequest) {
        const client = this.getClient(context);
        return client.getBlastForecastSummary(params);
    }

    getBlastForecastCampaigns(context: ClientContext, params: GetBlastForecastRequest) {
        const client = this.getClient(context);
        return client.getBlastForecastCampaigns(params);
    }
}

export default new BlastForecastClient();
